import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../css/BookshelfComponent.css';

const API_BASE = "http://197.156.76.122";

const BookshelfComponent = () => {
    const [books, setBooks] = useState([]);
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedFile, setSelectedFile] = useState('');
    const itemsPerPage = 10;

    useEffect(() => {
        const fetchBooks = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await axios.get(`${API_BASE}/api/book/`, {
                    params: { page }
                });

                if (response.data.results) {
                    setBooks(response.data.results);
                    setTotalCount(response.data.count);
                    setTotalPages(Math.ceil(response.data.count / itemsPerPage));
                } else {
                    setError('Unexpected API response');
                }
            } catch (err) {
                console.error('API error:', err);
                setError('Failed to fetch book data');
            } finally {
                setLoading(false);
            }
        };

        fetchBooks();
    }, [page]);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    // FILE DOWNLOAD MAP
    const fileDownloadLinks = {
        summary: `${API_BASE}/api/download/bookshelf_books_metadata.txt`,
        books_csv: `${API_BASE}/api/download/bookshelf_books.csv`,
    };

    const handleSelectChange = (event) => {
        setSelectedFile(event.target.value);
    };

    // ✅ FIXED DOWNLOAD (WORKS ON HTTP + HTTPS)
    const handleDownload = async () => {
        if (!selectedFile) return;

        try {
            const url = fileDownloadLinks[selectedFile];

            const response = await axios.get(url, {
                responseType: "blob",
            });

            const blob = new Blob([response.data]);
            const downloadUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = downloadUrl;

            link.setAttribute(
                "download",
                selectedFile === "summary"
                    ? "bookshelf_metadata.txt"
                    : "bookshelf_books.csv"
            );

            document.body.appendChild(link);
            link.click();
            link.remove();

            setTimeout(() => URL.revokeObjectURL(downloadUrl), 1000);

        } catch (err) {
            console.error("Download error:", err);
            setError("❌ Failed to download file");
        }
    };

    return (
        <div className="bookshelf-container">
            <div
                className="bookshelf-header"
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '1.5rem',
                }}
            >
                <h2 className="bookshelf-title">📘 Bookshelf</h2>

                <div
                    className="file-download-section"
                    style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                    <label style={{ fontWeight: '600' }}>Download</label>

                    <select
                        value={selectedFile}
                        onChange={handleSelectChange}
                        style={{ padding: '0.4rem 0.8rem', fontSize: '1rem' }}
                    >
                        <option value="">Select a file</option>
                        <option value="summary">Summary</option>
                        <option value="books_csv">Books CSV</option>
                    </select>

                    <button
                        onClick={handleDownload}
                        disabled={!selectedFile}
                        style={{
                            padding: '0.4rem 1rem',
                            backgroundColor: selectedFile ? '#4CAF50' : '#999',
                            color: 'white',
                            borderRadius: '6px',
                            fontWeight: '600',
                            cursor: selectedFile ? 'pointer' : 'not-allowed',
                            border: 'none',
                        }}
                    >
                        Download
                    </button>
                </div>
            </div>

            {loading ? (
                <div className="loading-message">Loading books...</div>
            ) : error ? (
                <div className="error-message">{error}</div>
            ) : (
                <>
                    <div className="results-wrapper centered">
                        <div className="results-meta-highlight">
                            Showing <strong>{(page - 1) * itemsPerPage + 1}</strong>–
                            <strong>{Math.min(page * itemsPerPage, totalCount)}</strong> of{' '}
                            <strong>{totalCount}</strong> books
                        </div>

                        <div className="results-list">
                            {books.map((book) => (
                                <div className="result-item" key={book.id}>
                                    <div className="result-content">
                                        <div className="title">
                                            <a href={book.url} target="_blank" rel="noreferrer">
                                                {book.title}
                                            </a>
                                        </div>

                                        <div className="authors-journal">
                                            <strong>Description:</strong> {book.description}
                                        </div>

                                        <div className="authors-journal">
                                            <strong>Details:</strong> {book.details}
                                        </div>

                                        <div className="authors-journal">
                                            <strong>Identifiers:</strong> {book.identifiers}
                                        </div>

                                        {book.full_text && (
                                            <div className="meta">
                                                <a
                                                    href={book.full_text}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="download-link"
                                                >
                                                    📥 Full Text
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* PAGINATION */}
                    <div className="pagination">
                        <button disabled={page === 1} onClick={() => handlePageChange(1)}>
                            ⏮ First
                        </button>
                        <button disabled={page === 1} onClick={() => handlePageChange(page - 1)}>
                            ◀ Prev
                        </button>
                        <span>
                            Page {page} of {totalPages}
                        </span>
                        <button disabled={page === totalPages} onClick={() => handlePageChange(page + 1)}>
                            Next ▶
                        </button>
                        <button disabled={page === totalPages} onClick={() => handlePageChange(totalPages)}>
                            Last ⏭
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default BookshelfComponent;
